import { render, staticRenderFns } from "./headerCard.vue?vue&type=template&id=0e8e745d&"
import script from "./headerCard.vue?vue&type=script&lang=js&"
export * from "./headerCard.vue?vue&type=script&lang=js&"
import style0 from "./headerCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports